import { createAction, props } from '@ngrx/store';

// OA
export const getOperatingAutorities = createAction(
  'get-OperatinAuthorities',
  props<{ params: any }>(),
);
export const getOperatingAuthoritiesReceived = createAction(
  'get-operatingAuthorities-received',
  props<{ params: any }>(),
);
export const getOperatingAuthoritiesFailed = createAction(
  'get-operatingAuthorities-failed',
);

export const getFees = createAction('get-fees', props<{ params: any }>());
export const getFeesRecieved = createAction(
  'get-fees-received',
  props<{ params: any }>(),
);
export const getFeesFailed = createAction('get-fees-failed');

export const getInvoices = createAction(
  'get-invoices',
  props<{ params: any }>(),
);
export const getInvoicesRecieved = createAction(
  'get-invoices-received',
  props<{ params: any }>(),
);
export const getInvoicesFailed = createAction('get-invoices-failed');

export const getFeesAndInvoices = createAction(
  'get-fees-and-invoices',
  props<{ params: any }>(),
);
export const getFeesAndInvoicesReceived = createAction(
  'get-fees-and-invoices-received',
  props<{ params: any }>(),
);

export const addOperatingAutorities = createAction(
  'add-OperatingAuthorities',
  props<{ params: any; OAType: boolean }>(),
);
export const addOperatingAutoritiesReceived = createAction(
  'add-operatingAuthorities-received',
  props<{ params: any }>(),
);
export const addOperatingAutoritiesFailed = createAction(
  'add-operatingAuthorities-failed',
);

export const editOperatingAuthorities = createAction(
  'edit-OperatingAuthorities',
  props<{ params: any }>(),
);
export const editOperatingAuthoritiesReceived = createAction(
  'edit-operatingAuthorities-received',
);
export const editOperatingAuthoritiesFailed = createAction(
  'edit-operatingAuthorities-failed',
);

export const getPaymentHistory = createAction(
  'get-payment-history',
  props<{ params: any }>(),
);
export const getPaymentHistoryReceived = createAction(
  'get-payment-history-received',
  props<{ params: any }>(),
);
export const getPaymentHistoryRecievedFailed = createAction(
  'get-payment-history-received-failed',
);

export const getNotifications = createAction('get-notifications');
export const getNotificationsReceived = createAction(
  'get-notifications-received',
  props<{ params: any }>(),
);
export const getNotificationsFailed = createAction('get-notifications-failed');

export const getNotificationMessage = createAction(
  'get-notification-message',
  props<{ params: any }>(),
);
export const getNotificationMessageReceived = createAction(
  'get-notification-message-received',
  props<{ params: any }>(),
);
export const getNotificationMessageFailed = createAction(
  'get-notification-message-failed',
);

export const getTerminals = createAction('get-terminals');
export const getTerminalsReceived = createAction(
  'get-terminals-received',
  props<{ params: any }>(),
);
export const getTerminalsFailed = createAction('get-terminals-failed');

export const getEvents = createAction('get-events', props<{ params: any }>());
export const getEventsReceived = createAction(
  'get-events-received',
  props<{ params: any }>(),
);
export const getEventsFailed = createAction('get-events-failed');

export const addEvent = createAction('add-event', props<{ params: any }>());
export const addEventReceived = createAction(
  'add-event-received',
  props<{ params: any }>(),
);
export const addEventFailed = createAction('add-event-failed');

export const editEvent = createAction('edit-event', props<{ params: any }>());
export const editEventReceived = createAction('edit-event-received');
export const editEventFailed = createAction('edit-event-failed');

export const terminateEvent = createAction(
  'terminate-event',
  props<{ params: any }>(),
);
export const terminateEventReceived = createAction('terminate-event-received');
export const terminateEventFailed = createAction('terminate-event-failed');

export const getReturningGuests = createAction(
  'returning-guests',
  props<{ params: any }>(),
);
export const getReturningGuestsReceived = createAction(
  'returning-guests-received',
  props<{ params: any }>(),
);
export const getReturningGuestsFailed = createAction('returning-guests-failed');

export const addReturningGuest = createAction(
  'add-returning-guest',
  props<{ params: any }>(),
);
export const addReturningGuestReceived = createAction(
  'add-returning-guest-received',
  props<{ params: any }>(),
);
export const addReturningGuestFailed = createAction(
  'add-returning-guest-failed',
);

export const editReturningGuest = createAction(
  'edit-returning-guest',
  props<{ params: any; requestId: any }>(),
);
export const editReturningGuestReceived = createAction(
  'edit-returning-guest-received',
);
export const editReturningGuestFailed = createAction(
  'edit-returning-guest-failed',
);

export const deleteReturningGuest = createAction(
  'delete-returning-guest',
  props<{ params: any; requestId: any }>(),
);
export const deleteReturningGuestSuccessfull = createAction(
  'delete-returning-guest-successfull',
);
export const deleteReturningGuestFailed = createAction(
  'delete-returning-guest-failed',
);

export const showPopup = createAction(
  'show-popup',
  props<{ params: boolean }>(),
);

export const showApplicationInfoPopup = createAction(
  'show-application-info-popup',
  props<{ params: boolean }>(),
);

export const showApplicationInfoPopupList = createAction(
  'show-application-info-popup-list',
  props<{ params: any }>(),
);
